import { ModelEventBus, SimulationEventBus } from "../../event-bus";
import ModelLoader from "../services/model-loader";
import RecentItemsService, { RecentFile } from "../services/storage/recent-items-service";
import { default as initial } from "./../models/initial.json";
import { StatechartsService } from "../services/statecharts/statecharts-service";
import LocalStorage from "../services/persistance/local-storage";
import router from "../../../router";
import { CodeSimulationService } from "../services/simulation/code/simulation-service-code";
import { DirtyState } from "../services/dirty-state";

export async function loadLastModel(
  cloudStatechartService: StatechartsService,
  simulationControl: CodeSimulationService,
  recentItemsService: RecentItemsService,
  modelLoader: ModelLoader,
  dirtyState: DirtyState,
  localStorage: LocalStorage,
  lastModelsList?: RecentFile[]
) {
  let lastModel: RecentFile = undefined;
  if (lastModelsList === undefined) {
    await recentItemsService
      .getRecentFilesList(false)
      .then((res) => {
        if (res.all.length > 0) {
          lastModel = res.all[0];
          lastModelsList = res.all;
        }
      })
      // to enable still loading of first statechart
      .catch();
  } else if (lastModelsList.length > 0) {
    lastModel = lastModelsList[0];
  }

  if (lastModel) {
    await loadAndShowSuccess(
      cloudStatechartService,
      simulationControl,
      modelLoader,
      lastModel.modelId,
      "last-cloud",
      lastModel.model.title
    );
  } else {
    loadNew(modelLoader, dirtyState, true);
    const hasLoggedInBefore = localStorage.get("hasLoggedInBefore");
    if (hasLoggedInBefore !== "true") {
      localStorage.set("hasLoggedInBefore", "true");
    }
  }
}

function loadNew(modelLoader: ModelLoader, dirtyState: DirtyState, setDirty = false) {
  if (setDirty) {
    dirtyState.setDirty(true);
  }
  modelLoader.loadModelFromJson(initial, undefined, "New initial Statechart created!");
  ModelEventBus.emit("modelChanged");
}

export async function loadAndShowSuccess(
  cloudStatechartService: StatechartsService,
  simulationControl: CodeSimulationService,
  modelLoader: ModelLoader,
  modelId: string,
  loadingType: "url" | "last-cloud",
  lastModelTitle: string
) {
  await cloudStatechartService
    .getModel(modelId)
    .then((res) => {
      let successMsg: string;
      switch (loadingType) {
        case "url":
          successMsg = "Model requested via URL parameters opened!";
          break;
        case "last-cloud":
          successMsg = "Last cloud Statechart '" + lastModelTitle + "' opened!";
          break;
      }
      loadStatechart(simulationControl, modelLoader, res, modelId, successMsg);

      if (loadingType === "url") {
        // get rid of url params to not create on every reload of page a new model
        router.push({ path: "/home" });
      }

      ModelEventBus.emit("modelChanged");
    })
    .catch();
}

export function loadStatechart(
  simulationControl: CodeSimulationService,
  modelLoader: ModelLoader,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jsonText: any,
  id?: string,
  successMsg?: string
) {
  if (simulationControl.getIsRunning()) SimulationEventBus.emit("stopSimulation");
  modelLoader.loadModelFromJson(jsonText, id, successMsg);
}
